export enum FeedbackTaxonomyLevel {
  L1 = "L1",
  L2 = "L2",
  L3 = "L3",
  THEME = "THEME",
  SUBTHEME = "SUBTHEME",
}
